module.exports = __webpack_public_path__ + "static/media/24.0e106294.png";